import { Component, Inject } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'

import { AlteracaoVm, LinhaMonitoramentoVm, normalizarCampoAlteracao } from '../../../core/models/monitoring-os.model'

// Puramente leitura — element.alteracoes já vem embutido na linha do
// search-paginated (sprint 9/10, seção 07), sem chamada HTTP própria. Lista do
// mais recente pro mais antigo, exatamente como o back devolve.
// Chaves em camelCase (forma canônica) — o campo cru passa por
// normalizarCampoAlteracao antes de indexar aqui, então funciona tanto com o
// contrato antigo (snake_case) quanto com uma futura migração pro camelCase.
const LABEL_CAMPO: Record<string, string> = {
  motorista: 'Motorista',
  veiculo: 'Veículo',
  dataInicio: 'Data de início',
  horaInicio: 'Hora de início',
  dataFinal: 'Data de fim',
  horaFinal: 'Hora de fim',
  valorCompra: 'Valor de compra',
  valorProposta: 'Valor de proposta',
  valorTarifario: 'Valor tarifário',
}

@Component({
  selector: 'modal-historico-alteracoes',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './modal-historico-alteracoes.component.html',
  styleUrl: './modal-historico-alteracoes.component.scss',
})
export class ModalHistoricoAlteracoesComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { item: LinhaMonitoramentoVm },
    private dialogRef: MatDialogRef<ModalHistoricoAlteracoesComponent>,
  ) {}

  labelCampo(alteracao: AlteracaoVm): string {
    return LABEL_CAMPO[normalizarCampoAlteracao(alteracao.campo)] ?? alteracao.campo
  }

  formatarQuando(iso: string): string {
    const d = new Date(iso)
    const data = d.toLocaleDateString('pt-BR')
    const hora = `${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`
    return `${data} ${hora}`
  }

  close(): void {
    this.dialogRef.close()
  }
}
